/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SurveyNeedingApprovalModel } from '../../models/survey-needing-approval-model';

export interface GetSurveysNeedingApprovalReport$Plain$Params {

/**
 * filter by clientrep id. optional
 */
  clientRepId?: number;
}

export function getSurveysNeedingApprovalReport$Plain(http: HttpClient, rootUrl: string, params?: GetSurveysNeedingApprovalReport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SurveyNeedingApprovalModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveysNeedingApprovalReport$Plain.PATH, 'get');
  if (params) {
    rb.query('clientRepId', params.clientRepId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SurveyNeedingApprovalModel>>;
    })
  );
}

getSurveysNeedingApprovalReport$Plain.PATH = '/api/Report/SurveysNeedingApproval';
